//  ----------      START   IMPORT  BLOCK       ----------

//  Components
import SocialsWidget from "../../../Widgets/General/LandingPage/Socials/SocialsWidget";
// Layout
import BaseLayout from "../../../Widgets/General/LandingPage/BaseLayout/BaseLayout";
// Config
import './SocialsPage.css';
//  ----------      END   IMPORT  BLOCK       ----------

function SocialsPage() {

  return (
    <BaseLayout>
      <SocialsWidget/>
    </BaseLayout>
  );
}

export default SocialsPage;